module.exports = {
  home: '/',
  clients: '/clients',
  login: '/login',
  appointments: '/appointments'
};
